import { TRANSFORMERS } from '@lexical/markdown';
import { INS } from '../../../SubjectViewer/Modules/AITools/ImpressionEditor/MarkdownEditor/transformers';
import { HORIZONTAL_RULE } from './horizontalRule';

export { HORIZONTAL_RULE } from './horizontalRule';

export const DEFAULT_TRANSFORMERS = [HORIZONTAL_RULE, ...TRANSFORMERS, INS];
